import React, { useEffect, useState } from 'react'
import { useFirebaseApp } from 'reactfire'
import RoutePath from '../atoms/RoutePath'
import ProductCard from '../molecules/ProductCard'
import SubMenu from '../molecules/SubMenu'

const Category=(props)=>{
  const category=props.match.params.category
  const firebase=useFirebaseApp()
  const firestore=firebase.firestore()

  const [state, setstate] = useState({products:[]})

  useEffect(()=>{
    document.documentElement.scrollTop=0
    firestore.collection(`products`).where('category','array-contains',category).get().then(
      snap=>{
        let products=[]
        snap.forEach(doc=>{
          products.push({id:doc.id,data:doc.data()})
        })
        setstate({
          products
        })
      }
    )
  },[firestore,category])
  return (
    <>
    <SubMenu category={category}/>
    <main className='category'>
      <RoutePath categoryUrl={category} category={` ${category[0].toUpperCase()+category.slice(1)}`}/>
      <div className='line-cont'>

        <div className="line"></div>
        </div>
      <div className="products">
        <div className="products-grid">
          {
            state.products &&
            state.products.map(p=>(
              <ProductCard key={p.data.name} product={`${category}/${p.data.subCategory[0]}/${p.id}`} name={p.data.name} price={p.data.price} image={p.data.images[0]} />
            ))
          }
        </div>
      </div>
    </main>
    </>
  )
}

export default Category
